import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getApiCall } from "../../service/httpCall";
import { API_LIST_OF_API_USERS } from "../../service/url";
import Loader from "../../components/partials/components/loader";
import { USER_ROLES } from "../../utilities/constant";
import { toast } from "react-toastify";
import { InputText } from "primereact/inputtext";

import { Storage } from "../../utilities/setting";

const ApiUsersTable = () => {
  const [apiUsers, setApiUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    async function checkUserRole() {
      const rawUser = Storage.getItem("user");
      if (!rawUser) {
        console.error("User not found in Storage");
        return null;
      }
      let user;
      try {
        user = JSON.parse(rawUser);
      } catch (e) {
        console.error("Invalid JSON", e);
        return null;
      }
      if (user.role) setLoggedInUserRole(user.role);
    }
    checkUserRole();
  }, []);

  useEffect(() => {
    if (!loggedInUserRole) return;
    if (loggedInUserRole !== USER_ROLES.SUPERADMIN) return;
    fetchApiUsers();
  }, [loggedInUserRole]);

  const fetchApiUsers = () => {
    setLoading(true);

    getApiCall(API_LIST_OF_API_USERS)
      .then((resp) => {
        const formatted = resp.map((item, index) => ({
          key: index + 1,
          id: item.id,
          user_id: item.user_id,
          name: item.user?.name || "-",
          email: item.user?.email || "-",
          created_at: item.created_at,
          updated_at: item.updated_at,
        }));

        setApiUsers(formatted);
      })
      .catch((err) => toast.error(err))
      .finally(() => setLoading(false));
  };

  const dateTemplate = (row, field) => {
    if (!row[field]) return "-";
    return new Date(row[field]).toLocaleString();
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="dash-section-card" style={{ marginBottom: 28 }}>
        <div className="dash-section-header">
          <span>API Users</span>
          {apiUsers.length > 0 && (
            <span className="dash-count-badge">{apiUsers.length}</span>
          )}
        </div>

        <div className="dash-table-toolbar">
          <div className="dash-search-wrap">
            <InputText
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder="Search API users…"
              className="dash-search-input"
            />
          </div>
        </div>

        <div style={{ overflowX: "auto" }}>
          <DataTable
            value={apiUsers}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            globalFilter={globalFilter}
            className="dash-datatable"
            emptyMessage="No API users found"
          >
            <Column field="user_id" header="User ID" />
            <Column field="name" header="Name" />

            <Column
              header="Created At"
              body={(row) => dateTemplate(row, "created_at")}
            />
            <Column
              header="Last Used"
              body={(row) => dateTemplate(row, "updated_at")}
            />
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default ApiUsersTable;
